<app-header></app-header>

<div class="page-title-area newsBg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Acasa</a></li>
                <li><a routerLink="/cariere">Cariere</a></li>
                <li>Anunt</li>
            </ul>
            <h2>{{career.title}}</h2>
        </div>
    </div>
</div>
<section class="bg my-5">
    <div class="container">
        <div class="row">
            <div class="col-12 newsDetail">
                <div class="img">
                    <div *ngIf="career.photo"><img [src]="setFilePath(career)" alt="test"></div>
                    <div *ngIf="!career.photo"><img src="../../../assets/img/placeImg.jpg" alt=""></div>
                </div>
                <div class="content">
                    <div class="date"></div>
                    <h3>{{career.title}}</h3>
                    <div [innerHTML]=career.content></div>
                </div>
            </div>
        </div>
    </div>
</section>
